// src/pages/Auth/LoginPage.js
import React, { useState } from 'react';
import { loginUser } from '../../auth/AuthService'; // Importa a função de login
import { useNavigate } from 'react-router-dom'; // Para redirecionar após o login
import './LoginPage.css'; // Estilos para a página de login

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // Hook para navegação

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null); // Limpa erros anteriores
    setLoading(true); // Ativa o estado de carregamento

    try {
      await loginUser(email, password);
      // Se o login for bem-sucedido, redireciona para o PDV ou para uma página protegida
      navigate('/pdv');
    } catch (err) {
      // Firebase Authentication retorna códigos de erro específicos
      let errorMessage = "Erro ao fazer login. Verifique suas credenciais.";
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        errorMessage = "E-mail ou senha inválidos.";
      } else if (err.code === 'auth/invalid-email') {
        errorMessage = "Formato de e-mail inválido.";
      }
      setError(errorMessage);
    } finally {
      setLoading(false); // Desativa o estado de carregamento
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">E-mail:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Senha:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <button type="submit" disabled={loading} className="login-btn">
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;